import React from 'react';

const Spinner = () => (
	<div className="spinner">
		<div className="spinner-moon" />
	</div>
);

export default Spinner;
